<template>
  <div id="footer" class="bg-2">
    <div id="infos-footer" class="bg-bf d-flex flex-column justify-content-end">
      <div
        class="bold info-menu-footer bg-bc py-2 pt-4 d-flex flex-row justify-content-start"
      >
        <img src="@/../public/elements/pin.png" alt="map" />
        <a href="#" class="c-g pl-3"
          >362 rue de la République<br />76230 Bois-Guillaume</a
        >
      </div>
      <div
        class="info-menu-footer bg-bc pt-3 pb-2 pb-5 d-flex flex-row justify-content-start"
      >
        <!-- <img src="@/../public/elements/icone-clock.png" alt="horaires" />
        <a href="#" class="c-g pl-3"
          >Lundi, Mardi, Vendredi de 9h à 12h et de 14h à 18h<br />Fermé le Mercredi / Jeudi et Samedi de 9h à 12h</a
        > -->
      </div>
      <div class="bas bg-w">
        <img src="@/../public/elements/logo-cbgr-full.png" alt="logo" />
      </div>
    </div>
    <div class="bleu bg-bc">
      <div class="docteurs">
        <div class="infos col-6 col-lg-4 c-w">
          <p><b>Dr Clémentine DECRETTE</b></p>
          <p><a href="tel:0235025583" class="phone">02 35 02 55 83</a></p>
          <p>&gt;&gt; <router-link tag="a" to="docteur-clementine-decrette">voir la fiche</router-link> &lt;&lt;</p>
        </div>
        <div class="infos col-6 col-lg-4 c-w">
          <p><b>Dr Thibault GANCEL</b></p>
          <p><a href="tel:0235590412" class="phone">02 35 59 04 12</a></p>
          <p>&gt;&gt; <router-link tag="a" to="docteur-thibault-gancel">voir la fiche</router-link> &lt;&lt;</p>
        </div>
        <div class="infos col-6 col-lg-4 c-w">
          <p><b>Dr Antoine GODDEFROY</b></p>
          <p><a href="tel:0235712185" class="phone">02 35 71 21 85</a></p>
          <p>&gt;&gt; <router-link tag="a" to="docteur-antoine-goddefroy">voir la fiche</router-link> &lt;&lt;</p>
        </div>
        <div class="infos col-6 col-lg-4 c-w">
          <p><b>Dr Edouard SOUBRANE</b></p>
          <p><a href="tel:0235345102" class="phone">02 35 34 51 02</a></p>
          <p>&gt;&gt; <router-link tag="a" to="docteur-edouard-soubrane">voir la fiche</router-link> &lt;&lt;</p>
        </div>
      </div>
    </div>
    <div class="blanc bg-w">
      <p class="c-bc">
        Copyright © 2020 <a href="#">CBGR</a> - Tous droits réservés. Conception
        et Réalisation : <a href="https://www.devinfluence.fr" target="new">DEV'INFLUENCE</a>. Crédits photos : <a href="https://www.davidmorganti.com/" target="new">David MORGANTI</a> -
        <router-link tag="a" to="mentions-legales">Mentions Légales</router-link>
      </p>
    </div>
  </div>
</template>
<script>
// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();
import { firebaseConfig } from "@/firebase/firebaseConfig";

export default {
  name: "esp-header",
  props: {
    dataPage: {
      type: Object,
    },
    dataIris: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    color1: function () {
      if (this.dataIris.customizableVar[0].value) {
        return this.dataIris.customizableVar[0].value;
      } else {
        return "0f555d";
      }
    },
    color2: function () {
      if (this.dataIris.customizableVar[1].value) {
        return this.dataIris.customizableVar[1].value;
      } else {
        return "0f555d";
      }
    },
    customizableVar1: function () {
      if (this.dataIris.customizableVar[0].value) {
        return this.dataIris.customizableVar[0].value;
      } else {
        return "0f555d";
      }
    },
  },
  methods: {
    formatLabelMenu(str) {
      return str.replace("<br>", " ");
    },
    getSrcMenuPage(idPage) {
      let page = this.$parent.dataIris.pages.find((page) => page.id === idPage);

      return ""; //require('@/html/elements/o-'+page.customizableVar[0].value.value+'.svg')
    },
  },
};
</script>

